var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVectorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0611 8.35399C18.9218 8.2146 18.7564 8.10402 18.5744 8.02858C18.3923 7.95314 18.1972 7.91431 18.0001 7.91431C17.8031 7.91431 17.6079 7.95314 17.4259 8.02858C17.2438 8.10402 17.0784 8.2146 16.9391 8.35399L12.3531 12.939C12.2594 13.0327 12.1322 13.0854 11.9996 13.0854C11.867 13.0854 11.7399 13.0327 11.6461 12.939L7.06113 8.35399C6.77986 8.07259 6.39834 7.91445 6.00048 7.91436C5.60262 7.91427 5.22102 8.07222 4.93963 8.35349C4.65823 8.63475 4.50009 9.01628 4.5 9.41413C4.49991 9.81199 4.65786 10.1936 4.93913 10.475L9.52513 15.061C9.85014 15.386 10.236 15.6439 10.6607 15.8198C11.0853 15.9957 11.5405 16.0862 12.0001 16.0862C12.4598 16.0862 12.9149 15.9957 13.3396 15.8198C13.7643 15.6439 14.1501 15.386 14.4751 15.061L19.0611 10.475C19.3423 10.1937 19.5003 9.81223 19.5003 9.41449C19.5003 9.01674 19.3423 8.63528 19.0611 8.35399Z",
    fill: "#04151F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorIcon);
export default __webpack_public_path__ + "static/media/vector_icon.e026dffda34f17c8d4a4c78c8358485f.svg";
export { ForwardRef as ReactComponent };